import { useEffect } from 'react';
import { useAuth0 } from '@brighte/passwordless-authenticator';
import { useStepperActions, useStepperActiveIndex } from '../../provider';

export const useProtected = (loginStepIndex: number | undefined = 0, protectedSteps: number[]) => {
  const activeIndex = useStepperActiveIndex();
  const { onEdit, onNext } = useStepperActions();
  const { verificationCompleted, user } = useAuth0();

  useEffect(() => {
    if (!user && !verificationCompleted && protectedSteps.includes(activeIndex)) {
      onEdit(loginStepIndex);
    }
    if (user && verificationCompleted && activeIndex === loginStepIndex) {
      // Advance to an explicit index rather than a relative increment: under React
      // StrictMode this mount effect is invoked twice, and a bare onNext() would apply
      // prev + 1 twice (0 → 2), skipping the step after login (Finance Purchase). An
      // absolute target keeps the auto-skip idempotent.
      onNext(loginStepIndex + 1);
    }
  }, [user, verificationCompleted, activeIndex]);
};
